import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { BaseFooter } from "./BaseFooter";
import { EditModeButton } from "./EditModeButton";
import { AIPanelToggleButton } from "./icon-buttons/AIPanelToggleButton";

import { useHomeRole } from "components/materials/home/use-home-role";
import { VerticalDivider } from "mds/components/VerticalDivider";
import { HomeRole } from "utils/urls";

export const HomeFooter: FC = () => {
  const { currentRole } = useHomeRole();
  const isStaff = currentRole !== HomeRole.STUDENT;
  const isAdmin = currentRole === HomeRole.ADMIN;

  return (
    <BaseFooter>
      <div
        className={twMerge(
          "flex h-full w-full items-center",
          isStaff ? "justify-around" : "justify-end",
        )}
      >
        <div className="flex h-full items-center gap-2">
          {isStaff && (
            <>
              <EditModeButton isDisabled={!isAdmin} />
              <VerticalDivider className="h-6 border-black-tint-90" />
            </>
          )}
          <AIPanelToggleButton />
        </div>
      </div>
    </BaseFooter>
  );
};
